import { Hidden, Flex, Button } from '@backyard-ui/core'
import { FilterOutline } from '@backyard-ui/icons'

import styles from '../page.styles'

interface FloatingFilterButtonProps {
  isVisible: boolean
  isScrolled: boolean
  onToggleFilters?: () => void
}

export const FloatingFilterButton = ({
  isVisible,
  isScrolled,
  onToggleFilters
}: FloatingFilterButtonProps) => {
  if (!isVisible) return null

  return (
    <Hidden above="lg">
      <Flex
        justify="center"
        className={styles().button({
          animation: isScrolled ? 'up' : 'down'
        })}>
        <Button
          iconLeft={<FilterOutline />}
          onClick={onToggleFilters || undefined}>
          Filtros
        </Button>
      </Flex>
    </Hidden>
  )
}
